import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["Collapsible","CollapsibleTrigger","CollapsibleContent"] */ "/app/src/components/_ui/collapsible.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DropdownMenu","DropdownMenuTrigger","DropdownMenuContent","DropdownMenuLabel","DropdownMenuItem"] */ "/app/src/components/_ui/dropdown-menu.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/_ui/sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/sidebar-link/sidebar-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/theme-provider/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/wiki/create-button/create-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/wiki/edit-button/edit-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/wiki/logo/logo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/wiki/sidebar-x/sidebar-x.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/wiki/theme-button/theme-button.tsx");
